import type { IResourceItem } from "@refinedev/core";

import AssessmentOutlined from "@mui/icons-material/AssessmentOutlined";
import DashboardOutlined from "@mui/icons-material/DashboardOutlined";
import PeopleOutlined from "@mui/icons-material/PeopleOutlined";
import PersonOutlined from "@mui/icons-material/PersonOutlined";

import { ANALYTICS_PERMISSION, ORG_SETTINGS_PERMISSION, PRACTITIONER_MANAGEMENT_PERMISSION } from "./permission-keys";

/**
|--------------------------------------------------
| Define the resources for the application
|
| `meta.requiredPermissions` lists featuresv2 keys (any-of). The access-control provider,
| ProtectedRoute and the header nav all read it through `hasRequiredPermissions` (VMD-796).
|--------------------------------------------------
*/
export const resources: IResourceItem[] = [
  {
    name: "dashboard",
    list: "/",
    meta: {
      label: "resources.dashboard",
      icon: <DashboardOutlined />,
    },
  },
  {
    name: "practitioner",
    list: "/practitioner",
    meta: {
      label: "resources.practitioner",
      icon: <PersonOutlined />,
      requiredPermissions: [PRACTITIONER_MANAGEMENT_PERMISSION],
    },
  },
  {
    name: "patients",
    list: "/patients",
    meta: {
      label: "resources.patients",
      icon: <PeopleOutlined />,
    },
  },
  {
    name: "analytics",
    list: "/analytics",
    meta: {
      label: "resources.analytics",
      icon: <AssessmentOutlined />,
      requiredPermissions: [ANALYTICS_PERMISSION],
    },
  },
  {
    name: "organization-settings",
    meta: {
      label: "resources.organizationSettings",
      requiredPermissions: [ORG_SETTINGS_PERMISSION],
    },
  },
];
